<template>
    <div class="p-2 border border-gray-200 bg-gray-50 rounded-md">
        <ul>
            <slot />
        </ul>
    </div>
</template>

<script>
export default {
    name: 'TopicSuggestions'
}
</script>
